module.exports = __webpack_public_path__ + "img/service3.2bb49765.png";